import { render, staticRenderFns } from "./BulkLocalizationFilter.vue?vue&type=template&id=d2ac9e40&scoped=true&"
import script from "./BulkLocalizationFilter.vue?vue&type=script&lang=js&"
export * from "./BulkLocalizationFilter.vue?vue&type=script&lang=js&"
import style0 from "./BulkLocalizationFilter.vue?vue&type=style&index=0&id=d2ac9e40&prod&lang=scss&"
import style1 from "./BulkLocalizationFilter.vue?vue&type=style&index=1&id=d2ac9e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ac9e40",
  null
  
)

export default component.exports